document.addEventListener("DOMContentLoaded", () => {
    const navButtons = document.querySelectorAll('[data-nav]');
    const header = document.querySelector("header");
    const hamburger = document.querySelector("header .hamburger");

    let previousScrollTop = window.scrollY;
    window.addEventListener("scroll", () => {
      const currentScrollTop = window.scrollY;
      if(currentScrollTop > previousScrollTop && currentScrollTop > 100){
          header.classList.add("scrolled-down");
          hamburger.classList.remove("open");
          header.classList.remove("top");
      }
      else {
          header.classList.remove("scrolled-down");
      }
      if(currentScrollTop < 200){
        header.classList.add("top");
      }
      previousScrollTop = currentScrollTop;
    })
  
    if (hamburger) {
      hamburger.addEventListener("click", () => {
        hamburger.classList.toggle("open");
      });
  
      window.addEventListener("click", (e) => {
        if (
          e.target.tagName !== "A" &&
          !e.target.closest(".hamburger") &&
          hamburger.classList.contains("open")
        ) {
          hamburger.classList.remove("open");
        }
      });
    }
    navButtons.forEach((btn) => {
      const href = btn.getAttribute("href");
      const currentPath = window.location.pathname;
      if (href === currentPath) {
        btn.classList.add("active");
      }
    });
    
  
  });
  